import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  input: {
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
});

export const cardStyle = {
  dealCard: {
    width: 2/5,
    minWidth: 680,
    minHeight: 100,
    margin: "50px",
    background: "white",
    boxShadow: "0 10px 25px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: "10px",
  },

  wideCard: {
    width: 5/6,
    minWidth: 960,
    minHeight: 400,
    margin: "50px",
    background: "white",
    boxShadow: "0 10px 25px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: "10px",
  },

  excelCard: {
    marginTop: "30px",
    background: "white",
    boxShadow: "0 10px 25px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: "10px",
  },
}

const rowStyle = {
  baseRow: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    marginTop: "2px",
    marginBottom: "2px",
  },
  labelRow: {
    display: "flex",
    justifyContent: "flex-end",
    alignSelf: "center",
    width: "40%",
    paddingRight: "10%",
  },
  GPTlabelRow: {
    display: "flex",
    justifyContent: "flex-end",
    alignSelf: "center",
    width: "40%",
  },
  GPTRow: {
    display: "flex",
    justifyContent: "flex-end",
    alignSelf: "center",
    width: "25%",
    paddingRight: "5%",
  },
  fieldRow: {
    display: "flex",
    justifyContent: "flex-start",
    width: "50%",
  },
  tableItems: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignSelf: "center",
    marginRight: "10%",
    border: "1px solid #ccc",
    paddingTop: "5px",
    paddingBottom: "7px",
    paddingLeft: "10px",
    paddingRight: "10px",
    fontSize: "17px",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: "10px",
    resize: "none",
  },
  tableComments: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignSelf: "center",
    marginLeft: "3%",
    border: "1px solid #ccc",
    paddingTop: "5px",
    paddingBottom: "7px",
    paddingLeft: "10px",
    paddingRight: "10px",
    fontSize: "17px",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: "10px",
    resize: "none",
  },
  notes: {
    width: "40%",
    display: "flex",
    justifyContent: "center",
    alignSelf: "center",
    marginLeft: "15%",
    border: "1px solid #ccc",
    paddingTop: "5px",
    paddingBottom: "7px",
    paddingLeft: "10px",
    paddingRight: "10px",
    fontSize: "17px",
    boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: "10px",
    resize: "none",
  },
};

export { useStyles, rowStyle };
